/**
 * Fanen Dokumenter på spillestedets arrangement (sak 229, V4, 0449).
 *
 * Arrangementet har én mappe i sin (skjulte) årgang, i det vanlige dokumentsystemet — samme form
 * som konsertens (0415). Svaret er bare mappas id: filene leses og skrives gjennom vedleggene
 * (`ownerType: 'folder'`), bak dokumentcellene, som alle andre mapper.
 */
import { z } from 'zod';

export const venueNightDocumentsDtoSchema = z
  .object({
    venueNightId: z.uuid(),
    /** Null til noen har bedt om mappa. `POST` lager den, og svarer det samme om den finnes. */
    folderId: z.uuid().nullable(),
  })
  .meta({ id: 'VenueNightDocuments' });

export type VenueNightDocumentsDto = z.infer<typeof venueNightDocumentsDtoSchema>;
